import { render } from "./DamageItem.vue?vue&type=template&id=0eb1c849&scoped=true"
import script from "./DamageItem.vue?vue&type=script&lang=js"
export * from "./DamageItem.vue?vue&type=script&lang=js"

import "./DamageItem.vue?vue&type=style&index=0&id=0eb1c849&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb1c849"]])

export default __exports__